var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M8.121.375v1.1H1.168V9.107H0V1.473A1.028,1.028,0,0,1,.34.694,1.163,1.163,0,0,1,1.168.375Zm1.738,2.2a1.13,1.13,0,0,1,.8.319,1,1,0,0,1,.34.753v7.634a1.028,1.028,0,0,1-.34.779,1.13,1.13,0,0,1-.8.319H3.477a1.165,1.165,0,0,1-.829-.319,1.027,1.027,0,0,1-.339-.779V3.643a1,1,0,0,1,.34-.753,1.167,1.167,0,0,1,.828-.319H9.859Zm0,8.706V3.643H3.477v7.634H9.859Z",
    transform: "translate(0 -0.375)",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white_copy.736292174e781fe7a3482646994d4402.svg";